// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z%27 fill=%27%231E1F2F%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.peer-com-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  display: flex;
  flex-direction: column;
  min-width: 328px;
}

.peer-com-container > div {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}

.peer-com-container .pagination-background {
  cursor: auto;
}

.peer-com-container .select-container {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  display: flex;
  justify-content: flex-start;
}

.peer-com-container select {
  width: 100%;
  opacity: 1;
  padding: 6px 10px;
  border-radius: 8px;
  border-width: 1px;
  border: 1px solid var(--color-brand);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat right 0.75rem center;
  background-size: 16px 16px;
  color: var(--text-primary);
  font-size: 13px;
}

.peer-com-container select:focus {
  outline: none;
}

.peer-com-table-spacer {
  max-height: 8px;
}

.peer-com-container .peer-com-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
  margin-top: 10px;
}

.peer-com-container .peer-com-table thead th svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: -4px;
  transition: transform 0.2s ease;
}

.peer-com-container .peer-com-table thead th {
  border-bottom: 1px solid var(--border-line);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0;
  color: var(--text-subheader);
  vertical-align: sub;
  white-space: nowrap;
  height: 26px;
  padding-bottom: 0px;
  box-sizing: border-box;
}

.peer-com-container .peer-com-table thead th div {
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 2px;
}

.peer-com-container .peer-com-table thead th.no div,
.peer-com-container .peer-com-table thead th.ticker div,
.peer-com-container .peer-com-table thead th.tickerName div,
.peer-com-container .peer-com-table thead th.name div,
.peer-com-container .peer-com-table thead th.ctry div {
  justify-content: flex-start;
}

.peer-com-container .peer-com-table thead th:first-child,
.peer-com-container .peer-com-table thead th:last-child {
  width: 8px;
  border-bottom: 0px;
}

.peer-com-container .peer-com-table thead .no {
  text-align: start;
  width: 16px;
  padding-left: 8px;
  padding-right: 8px;
}

.peer-com-container .peer-com-table thead .ticker {
  text-align: start;
  width: 100px;
}

.peer-com-container .peer-com-table thead .tickerName {
  text-align: start;
}

/* Split "Ticker" / "Co name" header cells (small screen). The body keeps a
   single cell spanning both via colSpan={2}. Ticker is fixed; the name column
   uses auto width so it absorbs the table's leftover space (table-layout is
   fixed), keeping the other fixed-width columns at their declared sizes. */
.peer-com-container .peer-com-table thead th.tickerName--ticker {
  width: 72px;
}
.peer-com-container .peer-com-table thead th.tickerName--name {
  width: auto;
  padding-left: 0;
}

.peer-com-container .peer-com-table thead .name {
  text-align: start;
  width: 20%;
}

.peer-com-container .peer-com-table thead .ctry {
  padding-right: 8px;
  width: 5%;
}

.peer-com-container .peer-com-table thead .last,
.peer-com-container .peer-com-table thead .pctchng,
.peer-com-container .peer-com-table thead .mktcap,
.peer-com-container .peer-com-table thead .peratio,
.peer-com-container .peer-com-table thead .divyield,
.peer-com-container .peer-com-table thead .perf1M,
.peer-com-container .peer-com-table thead .perf3M,
.peer-com-container .peer-com-table thead .perf6M,
.peer-com-container .peer-com-table thead .perf1Y,
.peer-com-container .peer-com-table thead .beta,
.peer-com-container .peer-com-table thead .avgvol30,
.peer-com-container .peer-com-table thead .rsi,
.peer-com-container .peer-com-table thead .ma5d,
.peer-com-container .peer-com-table thead .ma25d,
.peer-com-container .peer-com-table thead .per,
.peer-com-container .peer-com-table thead .pbr,
.peer-com-container .peer-com-table thead .roe,
.peer-com-container .peer-com-table thead .overall,
.peer-com-container .peer-com-table thead .fundamental,
.peer-com-container .peer-com-table thead .earnings,
.peer-com-container .peer-com-table thead .valuation,
.peer-com-container .peer-com-table thead .performance,
.peer-com-container .peer-com-table thead .risk,
.peer-com-container .peer-com-table thead .targetprice,
.peer-com-container .peer-com-table thead .brokerrating {
  text-align: end;
}

.peer-com-container .peer-com-table thead .last {
  width: 14%;
}
.peer-com-container .peer-com-table thead .pctchng {
  width: 12%;
}
.peer-com-container .peer-com-table thead .mktcap {
  width: 125px;
}
.peer-com-container .peer-com-table thead .mktcap span {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-subheader);
}
.peer-com-container .peer-com-table thead .peratio,
.peer-com-container .peer-com-table thead .divyield,
.peer-com-container .peer-com-table thead .beta,
.peer-com-container .peer-com-table thead .rsi,
.peer-com-container .peer-com-table thead .ma5d,
.peer-com-container .peer-com-table thead .ma25d,
.peer-com-container .peer-com-table thead .per,
.peer-com-container .peer-com-table thead .pbr,
.peer-com-container .peer-com-table thead .roe,
.peer-com-container .peer-com-table thead .earnings,
.peer-com-container .peer-com-table thead .valuation {
  width: 90px;
}
.peer-com-container .peer-com-table thead .coscore {
  width: 144px;
  text-align: end;
  padding-right: 8px;
}
.peer-com-container .peer-com-table thead .consensus,
.peer-com-container .peer-com-table thead .perf1M,
.peer-com-container .peer-com-table thead .perf3M,
.peer-com-container .peer-com-table thead .perf6M,
.peer-com-container .peer-com-table thead .perf1Y,
.peer-com-container .peer-com-table thead .targetprice {
  width: 120px;
}
.peer-com-container .peer-com-table thead .avgvol30,
.peer-com-container .peer-com-table thead .performance {
  width: 115px;
}
.peer-com-container .peer-com-table thead .overall,
.peer-com-container .peer-com-table thead .risk {
  width: 80px;
}
.peer-com-container .peer-com-table thead .fundamental {
  width: 125px;
}
.peer-com-container .peer-com-table thead .brokerrating {
  width: 145px;
}
.peer-com-container .peer-com-table thead .numofbrokers {
  text-align: center;
}

.peer-com-container .peer-com-table thead th:nth-last-child(2) {
  padding-right: 0px;
}

.peer-com-container .peer-com-table thead .lastcolumn {
  width: 0;
}

.peer-com-container .peer-com-table tbody tr {
  vertical-align: middle;
  height: 56px;
}

.peer-com-container .peer-com-table tbody tr:nth-child(2n) {
  background-color: var(--row-dark);
}

.peer-com-container .peer-com-table tbody .numofbrokers {
  text-align: center;
}

.peer-com-container .peer-com-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  white-space: nowrap;
  box-sizing: border-box;
  font-size: 12px;
  padding-top: 12px;
  padding-bottom: 8px;
  padding-right: 4px;
}

.peer-com-container .peer-com-table tbody td:first-child {
  padding-left: 8px;
}

.peer-com-container .peer-com-table tbody td.no {
  text-align: justify;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-subheader);
  padding-right: 4px;
  padding-top: 12px;
  padding-left: 8px;
  vertical-align: top;
}

.peer-com-container .peer-com-table tbody td.ctry {
  text-align: center;
  padding-left: 24px;
  padding-top: 0px;
  padding-right: 16px;
  vertical-align: middle;
}

.peer-com-container .peer-com-table tbody td.ctry svg {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  display: block;
  margin: 0 auto;
}

.peer-com-container .peer-com-table tbody td.ticker {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  color: var(--text-ticker);
  padding-right: 4px;
  cursor: pointer;
}

.peer-com-container .peer-com-table tbody td.ticker.link-enabled {
  cursor: pointer;
}
.peer-com-container .peer-com-table tbody td.name {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0;
  color: var(--text-subheader);
  text-decoration: none;
}

.peer-com-container .peer-com-table tbody td.name.link-enabled {
  cursor: pointer;
}

.peer-com-container .peer-com-table tbody td.tickerName {
  text-align: left;
  padding-left: 36px;
}

.peer-com-container .peer-com-table tbody td.tickerName .ticker {
  font-weight: 700;
  font-size: 16px;
  color: var(--text-ticker);
  cursor: pointer;
}

.peer-com-container .peer-com-table tbody td.tickerName .name {
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0;
  color: var(--text-primary);
  padding-right: 4px;
  text-decoration: none;
}

.peer-com-container .peer-com-table tbody td.tickerName .tickerNameSmallScreen {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.peer-com-container
  .peer-com-table
  tbody
  td.tickerName
  .tickerNameSmallScreen
  .name {
  width: 100%;
}

.peer-com-container .peer-com-table tbody td.last,
.peer-com-container .peer-com-table tbody td.pctchng,
.peer-com-container .peer-com-table tbody td.mktcap,
.peer-com-container .peer-com-table tbody td.peratio,
.peer-com-container .peer-com-table tbody td.divyield,
.peer-com-container .peer-com-table tbody td.targetprice,
.peer-com-container .peer-com-table tbody td.beta,
.peer-com-container .peer-com-table tbody td.avgvol30,
.peer-com-container .peer-com-table tbody td.rsi,
.peer-com-container .peer-com-table tbody td.ma5d,
.peer-com-container .peer-com-table tbody td.ma25d,
.peer-com-container .peer-com-table tbody td.per,
.peer-com-container .peer-com-table tbody td.pbr,
.peer-com-container .peer-com-table tbody td.roe,
.peer-com-container .peer-com-table tbody td.perf1M,
.peer-com-container .peer-com-table tbody td.perf3M,
.peer-com-container .peer-com-table tbody td.perf6M,
.peer-com-container .peer-com-table tbody td.perf1Y {
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0;
  text-align: right;
  padding-right: 4px;
  color: var(--text-primary);
}

.peer-com-container .peer-com-table tbody td.mktcap span {
  font-size: 11px;
  line-height: 100%;
}

.peer-com-container .peer-com-table tbody td.coscore,
.peer-com-container .peer-com-table tbody td.div-consensus,
.peer-com-container .peer-com-table tbody td.overall,
.peer-com-container .peer-com-table tbody td.fundamental,
.peer-com-container .peer-com-table tbody td.earnings,
.peer-com-container .peer-com-table tbody td.valuation,
.peer-com-container .peer-com-table tbody td.performance,
.peer-com-container .peer-com-table tbody td.risk,
.peer-com-container .peer-com-table tbody td.brokerrating {
  vertical-align: middle;
  padding-right: 8px;
  text-align: center;
}

.peer-com-container .peer-com-table tbody td.coscore span,
.peer-com-container .peer-com-table tbody td.overall span,
.peer-com-container .peer-com-table tbody td.fundamental span,
.peer-com-container .peer-com-table tbody td.earnings span,
.peer-com-container .peer-com-table tbody td.valuation span,
.peer-com-container .peer-com-table tbody td.performance span,
.peer-com-container .peer-com-table tbody td.risk span {
  width: 36px;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  border-radius: 1px;
  white-space: nowrap;
  padding-top: 3px;
  padding-bottom: 3px;
}

.peer-com-container .peer-com-table tbody td.div-consensus span,
.peer-com-container .peer-com-table tbody td.brokerrating span {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  border-radius: 1px;
  white-space: nowrap;
  padding-top: 3px;
  padding-bottom: 3px;
}

.peer-com-container .peer-com-table tbody td.coscore .score,
.peer-com-container .peer-com-table tbody td.overall .score,
.peer-com-container .peer-com-table tbody td.fundamental .score,
.peer-com-container .peer-com-table tbody td.earnings .score,
.peer-com-container .peer-com-table tbody td.valuation .score,
.peer-com-container .peer-com-table tbody td.performance .score,
.peer-com-container .peer-com-table tbody td.risk .score,
.peer-com-container .peer-com-table tbody td.brokerrating .score {
  background-color: var(--surface-secondary);
  color: var(--text-primary);
  text-align: center;
}

.peer-com-container .peer-com-table tbody td.coscore .score-10,
.peer-com-container .peer-com-table tbody td.overall .score-10,
.peer-com-container .peer-com-table tbody td.fundamental .score-10,
.peer-com-container .peer-com-table tbody td.earnings .score-10,
.peer-com-container .peer-com-table tbody td.valuation .score-10,
.peer-com-container .peer-com-table tbody td.performance .score-10,
.peer-com-container .peer-com-table tbody td.risk .score-10,
.peer-com-container .peer-com-table tbody td.brokerrating .score-10 {
  background-color: var(--surface-brand);
  color: var(--text-invert);
  text-align: center;
}

.peer-com-container .peer-com-table tbody td.div-consensus .strongbuy {
  background-color: var(--heatmap-up-5);
  color: var(--text-invert);
}
.peer-com-container .peer-com-table tbody td.firstcolumn,
.peer-com-container .peer-com-table tbody td.lastcolumn {
  width: 0;
}
.peer-com-container .peer-com-table tbody td:nth-last-child(2) {
  padding-right: 0px;
}

.peer-com-container .sortbtn {
  vertical-align: middle;
}
.peer-com-container .rec-strong-buy {
  background-color: var(--heatmap-up-5);
  color: var(--text-invert);
  padding: 3px 8px;
}
.peer-com-container .rec-buy {
  background-color: var(--heatmap-up-4);
  color: var(--text-invert);
  text-align: center;
  padding: 3px 8px;
}
.peer-com-container .rec-hold {
  background-color: var(--surface-secondary);
  color: var(--text-primary);
  text-align: center;
  padding: 3px 8px;
}
.peer-com-container .rec-reduce {
  background-color: var(--heatmap-down-4);
  color: var(--text-invert);
  text-align: center;
  padding: 3px 8px;
}
.peer-com-container .rec-sell {
  background-color: var(--heatmap-down-6);
  color: var(--text-invert);
  text-align: center;
  padding: 3px 8px;
}
.peer-com-container .peer-com-whitespace {
  height: 24px;
}

.peer-com-container .alignRight {
  display: flex;
  justify-content: flex-end;
}
.peer-com-container .alignCenter {
  display: flex;
  justify-content: center;
}
.peer-com-container .per-whiteBorder {
  border-top: 1px solid var(--surface-primary);
  border-bottom: 1px solid var(--surface-primary);
}
.peer-com-container .peer-com-tbl-cel-flex-container {
  display: flex;
  align-items: center;
  max-width: 90%;
}
.peer-com-container .peer-com-tbl-cel-text {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Small screen only (isSmallScreen = container < 768px). table-layout is fixed,
   so column sizing must come from \`width\`. Mirrors StockPeer: give "Rank" room
   (16px + 8/8 padding left no space, so the text overflowed onto the next
   column) and fix the last data column at 139px with text truncation. */
@container (max-width: 767.98px) {
  .peer-com-container .peer-com-table thead .no {
    width: 37px;
    padding-left: 0;
    padding-right: 0;
  }
  .peer-com-container .peer-com-table thead th:nth-last-child(2),
  .peer-com-container .peer-com-table tbody td:nth-last-child(2) {
    width: 139px;
  }
  .peer-com-container .peer-com-table tbody td:nth-last-child(2),
  .peer-com-container .peer-com-table tbody td:nth-last-child(2) > div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

@container (min-width: 768px) {
  .peer-com-container .select-container {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 14px;
  }

  .peer-com-container select {
    font-size: 16px;
    padding: 8px 16px;
  }

  .peer-com-table-spacer {
    max-height: unset;
    height: 8px;
  }

  .peer-com-container .peer-com-table thead th {
    height: 32px;
    &.name {
      width: 35%;
      min-width: 35%;
    }
    &:nth-last-child(2) {
      text-align: right;
      padding-right: 0px;
    }
  }

  .peer-com-container .peer-com-table thead th:first-child,
  .peer-com-container .peer-com-table thead th:last-child {
    width: 22px;
  }

  .peer-com-container .peer-com-table thead .no {
    width: 20px;
    padding-left: 0;
  }
  .peer-com-container .peer-com-table thead .tickerName {
    padding-left: 8px;
  }
  .peer-com-container .peer-com-table thead .numofbrokers {
    width: 180px;
  }

  .peer-com-container .peer-com-table tbody tr {
    height: 40px;
  }

  .peer-com-container .peer-com-table tbody td {
    font-size: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 8px;

    &:first-child {
      padding-left: 24px;
    }
    &.no {
      padding-top: 4px;
      padding-left: 0;
      vertical-align: middle;
    }
    &.ctry {
      padding-top: 4px;
      padding-right: 8px;
      vertical-align: middle;
    }
    &.name {
    }
    &.tickerName {
      padding-left: 8px;
    }
    &.tickerName .name {
      font-size: 12px;
      padding-right: 8px;
    }
    &:nth-last-child(2) {
      padding-right: 0px;
    }
    &:last-child {
      padding-right: 22px;
    }
  }

  .peer-com-container .peer-com-table tbody td.coscore span,
  .peer-com-container .peer-com-table tbody td.overall span,
  .peer-com-container .peer-com-table tbody td.fundamental span,
  .peer-com-container .peer-com-table tbody td.earnings span,
  .peer-com-container .peer-com-table tbody td.valuation span,
  .peer-com-container .peer-com-table tbody td.performance span,
  .peer-com-container .peer-com-table tbody td.risk span {
    width: 44px;
  }

  .peer-com-container .peer-com-table thead .ticker,
  .peer-com-container .peer-com-table tbody td.ticker,
  .peer-com-container .peer-com-table thead .ctry,
  .peer-com-container .peer-com-table tbody td.ctry {
    padding-left: 16px;
  }

  .peer-com-container .custom-select-wrapper {
    max-width: 345px;
    width: 100%;
  }
}

@container (min-width: 1200px) {
  .peer-com-container .peer-com-table tbody td.pctchng {
    background-color: transparent;
  }
  .peer-com-container .peer-com-table tbody td.pctchng.positive {
    color: var(--text-up-color);
  }
  .peer-com-container .peer-com-table tbody td.pctchng.negative,
  .peer-com-container .peer-com-table tbody td.pctchng.negative-small {
    color: var(--text-down-color);
  }
  .peer-com-container .peer-com-table tbody td.pctchng.nochange {
    color: var(--text-unchg-color);
  }

  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d.positive,
  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d.positive {
    color: var(--text-up-color);
  }
  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d.negative,
  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d.negative {
    color: var(--text-down-color);
  }
  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d.nochange,
  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d.nochange {
    color: var(--text-unchg-color);
  }

  .peer-com-container.tab-technical .peer-com-table thead th.ma5d,
  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d,
  .peer-com-container.tab-technical .peer-com-table thead th.ma25d,
  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d {
    min-width: 120px;
    max-width: 120px;
    width: 120px;
  }
  .peer-com-container.tab-technical .peer-com-table thead th.beta,
  .peer-com-container.tab-technical .peer-com-table tbody td.beta {
    min-width: 80px;
    width: 80px;
  }
  .peer-com-container.tab-technical .peer-com-table thead th.avgvol30,
  .peer-com-container.tab-technical .peer-com-table tbody td.avgvol30 {
    min-width: 120px;
    width: 120px;
  }

  .peer-com-container.tab-fundamentals .peer-com-table thead th.mktcap,
  .peer-com-container.tab-fundamentals .peer-com-table tbody td.mktcap {
    width: 125px;
    min-width: 125px;
  }
  .peer-com-container.tab-fundamentals .peer-com-table thead th.per,
  .peer-com-container.tab-fundamentals .peer-com-table tbody td.per,
  .peer-com-container.tab-fundamentals .peer-com-table thead th.pbr,
  .peer-com-container.tab-fundamentals .peer-com-table tbody td.pbr,
  .peer-com-container.tab-fundamentals .peer-com-table thead th.roe,
  .peer-com-container.tab-fundamentals .peer-com-table tbody td.roe {
    width: 90px;
    min-width: 90px;
  }

  .peer-com-container.tab-performance .peer-com-table thead th.pctchng,
  .peer-com-container.tab-performance .peer-com-table tbody td.pctchng {
    padding-right: 42px;
  }
  .peer-com-container.tab-performance .peer-com-table thead th.last,
  .peer-com-container.tab-performance .peer-com-table tbody td.last {
    padding-right: 42px;
  }
  .peer-com-container.tab-performance .peer-com-table tbody td.perf1Y {
    padding-right: 8px;
  }

  .peer-com-container.tab-summary .peer-com-table thead th.divyield,
  .peer-com-container.tab-summary .peer-com-table tbody td.divyield {
    max-width: 128px;
    min-width: 128px;
    width: 128px;
  }

  .peer-com-container .peer-com-table tbody td.perf1M,
  .peer-com-container .peer-com-table tbody td.perf3M,
  .peer-com-container .peer-com-table tbody td.perf6M,
  .peer-com-container .peer-com-table tbody td.perf1Y {
    border-left: 1px solid var(--surface-primary);
  }
  .peer-com-container .peer-com-table thead th.perf1M,
  .peer-com-container .peer-com-table thead th.perf3M,
  .peer-com-container .peer-com-table thead th.perf6M,
  .peer-com-container .peer-com-table thead th.perf1Y {
    text-align: center;
  }

  .peer-com-container .peer-com-table thead th.brokerrating,
  .peer-com-container .peer-com-table tbody td.brokerrating {
    padding-right: 16px;
  }
  .peer-com-container .peer-com-table thead th.numofbrokers {
    text-align: center;
  }
  .peer-com-container .peer-com-table thead th.targetprice,
  .peer-com-container .peer-com-table tbody td.targetprice {
    min-width: 150px;
    max-width: 150px;
    width: 150px;
  }
}

.peer-com-container .peer-com-table tbody td.nochange {
  color: var(--text-unchg-color);
}
.peer-com-container .peer-com-table tbody td.positive {
  color: var(--text-up-color);
}
.peer-com-container .peer-com-table tbody td.negative,
.peer-com-container .peer-com-table tbody td.negative-small {
  color: var(--text-down-color);
}

.sort-icon-asc path,
.sort-icon-desc path {
  fill: var(--color-brand);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/SectorPeerComparisonWidget/SectorPeerComparisonWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB;kCACgC;EAChC,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;2EAG2E;AAC3E;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;;;;;;;;;;;EAWE,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;EAME,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;;EAEE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;wEAGwE;AACxE;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ;MACE,UAAU;MACV,cAAc;IAChB;IACA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB;MACE,kBAAkB;IACpB;IACA;MACE,gBAAgB;MAChB,eAAe;MACf,sBAAsB;IACxB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,sBAAsB;IACxB;IACA;IACA;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,kBAAkB;IACpB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,mBAAmB;IACrB;EACF;;EAEA;;;;;;;IAOE,WAAW;EACb;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;;EAEA;;;;IAIE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;;IAEE,eAAe;IACf,WAAW;EACb;EACA;;IAEE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;EACA;;;;;;IAME,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;;;;IAIE,6CAA6C;EAC/C;EACA;;;;IAIE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":[".peer-com-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  display: flex;\n  flex-direction: column;\n  min-width: 328px;\n}\n\n.peer-com-container > div {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n}\n\n.peer-com-container .pagination-background {\n  cursor: auto;\n}\n\n.peer-com-container .select-container {\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.peer-com-container select {\n  width: 100%;\n  opacity: 1;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border-width: 1px;\n  border: 1px solid var(--color-brand);\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: url(\"data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z' fill='%231E1F2F'/></svg>\")\n    no-repeat right 0.75rem center;\n  background-size: 16px 16px;\n  color: var(--text-primary);\n  font-size: 13px;\n}\n\n.peer-com-container select:focus {\n  outline: none;\n}\n\n.peer-com-table-spacer {\n  max-height: 8px;\n}\n\n.peer-com-container .peer-com-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n  table-layout: fixed;\n  margin-top: 10px;\n}\n\n.peer-com-container .peer-com-table thead th svg {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: -4px;\n  transition: transform 0.2s ease;\n}\n\n.peer-com-container .peer-com-table thead th {\n  border-bottom: 1px solid var(--border-line);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  vertical-align: sub;\n  white-space: nowrap;\n  height: 26px;\n  padding-bottom: 0px;\n  box-sizing: border-box;\n}\n\n.peer-com-container .peer-com-table thead th div {\n  cursor: pointer;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  gap: 2px;\n}\n\n.peer-com-container .peer-com-table thead th.no div,\n.peer-com-container .peer-com-table thead th.ticker div,\n.peer-com-container .peer-com-table thead th.tickerName div,\n.peer-com-container .peer-com-table thead th.name div,\n.peer-com-container .peer-com-table thead th.ctry div {\n  justify-content: flex-start;\n}\n\n.peer-com-container .peer-com-table thead th:first-child,\n.peer-com-container .peer-com-table thead th:last-child {\n  width: 8px;\n  border-bottom: 0px;\n}\n\n.peer-com-container .peer-com-table thead .no {\n  text-align: start;\n  width: 16px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.peer-com-container .peer-com-table thead .ticker {\n  text-align: start;\n  width: 100px;\n}\n\n.peer-com-container .peer-com-table thead .tickerName {\n  text-align: start;\n}\n\n/* Split \"Ticker\" / \"Co name\" header cells (small screen). The body keeps a\n   single cell spanning both via colSpan={2}. Ticker is fixed; the name column\n   uses auto width so it absorbs the table's leftover space (table-layout is\n   fixed), keeping the other fixed-width columns at their declared sizes. */\n.peer-com-container .peer-com-table thead th.tickerName--ticker {\n  width: 72px;\n}\n.peer-com-container .peer-com-table thead th.tickerName--name {\n  width: auto;\n  padding-left: 0;\n}\n\n.peer-com-container .peer-com-table thead .name {\n  text-align: start;\n  width: 20%;\n}\n\n.peer-com-container .peer-com-table thead .ctry {\n  padding-right: 8px;\n  width: 5%;\n}\n\n.peer-com-container .peer-com-table thead .last,\n.peer-com-container .peer-com-table thead .pctchng,\n.peer-com-container .peer-com-table thead .mktcap,\n.peer-com-container .peer-com-table thead .peratio,\n.peer-com-container .peer-com-table thead .divyield,\n.peer-com-container .peer-com-table thead .perf1M,\n.peer-com-container .peer-com-table thead .perf3M,\n.peer-com-container .peer-com-table thead .perf6M,\n.peer-com-container .peer-com-table thead .perf1Y,\n.peer-com-container .peer-com-table thead .beta,\n.peer-com-container .peer-com-table thead .avgvol30,\n.peer-com-container .peer-com-table thead .rsi,\n.peer-com-container .peer-com-table thead .ma5d,\n.peer-com-container .peer-com-table thead .ma25d,\n.peer-com-container .peer-com-table thead .per,\n.peer-com-container .peer-com-table thead .pbr,\n.peer-com-container .peer-com-table thead .roe,\n.peer-com-container .peer-com-table thead .overall,\n.peer-com-container .peer-com-table thead .fundamental,\n.peer-com-container .peer-com-table thead .earnings,\n.peer-com-container .peer-com-table thead .valuation,\n.peer-com-container .peer-com-table thead .performance,\n.peer-com-container .peer-com-table thead .risk,\n.peer-com-container .peer-com-table thead .targetprice,\n.peer-com-container .peer-com-table thead .brokerrating {\n  text-align: end;\n}\n\n.peer-com-container .peer-com-table thead .last {\n  width: 14%;\n}\n.peer-com-container .peer-com-table thead .pctchng {\n  width: 12%;\n}\n.peer-com-container .peer-com-table thead .mktcap {\n  width: 125px;\n}\n.peer-com-container .peer-com-table thead .mktcap span {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-subheader);\n}\n.peer-com-container .peer-com-table thead .peratio,\n.peer-com-container .peer-com-table thead .divyield,\n.peer-com-container .peer-com-table thead .beta,\n.peer-com-container .peer-com-table thead .rsi,\n.peer-com-container .peer-com-table thead .ma5d,\n.peer-com-container .peer-com-table thead .ma25d,\n.peer-com-container .peer-com-table thead .per,\n.peer-com-container .peer-com-table thead .pbr,\n.peer-com-container .peer-com-table thead .roe,\n.peer-com-container .peer-com-table thead .earnings,\n.peer-com-container .peer-com-table thead .valuation {\n  width: 90px;\n}\n.peer-com-container .peer-com-table thead .coscore {\n  width: 144px;\n  text-align: end;\n  padding-right: 8px;\n}\n.peer-com-container .peer-com-table thead .consensus,\n.peer-com-container .peer-com-table thead .perf1M,\n.peer-com-container .peer-com-table thead .perf3M,\n.peer-com-container .peer-com-table thead .perf6M,\n.peer-com-container .peer-com-table thead .perf1Y,\n.peer-com-container .peer-com-table thead .targetprice {\n  width: 120px;\n}\n.peer-com-container .peer-com-table thead .avgvol30,\n.peer-com-container .peer-com-table thead .performance {\n  width: 115px;\n}\n.peer-com-container .peer-com-table thead .overall,\n.peer-com-container .peer-com-table thead .risk {\n  width: 80px;\n}\n.peer-com-container .peer-com-table thead .fundamental {\n  width: 125px;\n}\n.peer-com-container .peer-com-table thead .brokerrating {\n  width: 145px;\n}\n.peer-com-container .peer-com-table thead .numofbrokers {\n  text-align: center;\n}\n\n.peer-com-container .peer-com-table thead th:nth-last-child(2) {\n  padding-right: 0px;\n}\n\n.peer-com-container .peer-com-table thead .lastcolumn {\n  width: 0;\n}\n\n.peer-com-container .peer-com-table tbody tr {\n  vertical-align: middle;\n  height: 56px;\n}\n\n.peer-com-container .peer-com-table tbody tr:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.peer-com-container .peer-com-table tbody .numofbrokers {\n  text-align: center;\n}\n\n.peer-com-container .peer-com-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-size: 12px;\n  padding-top: 12px;\n  padding-bottom: 8px;\n  padding-right: 4px;\n}\n\n.peer-com-container .peer-com-table tbody td:first-child {\n  padding-left: 8px;\n}\n\n.peer-com-container .peer-com-table tbody td.no {\n  text-align: justify;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  padding-right: 4px;\n  padding-top: 12px;\n  padding-left: 8px;\n  vertical-align: top;\n}\n\n.peer-com-container .peer-com-table tbody td.ctry {\n  text-align: center;\n  padding-left: 24px;\n  padding-top: 0px;\n  padding-right: 16px;\n  vertical-align: middle;\n}\n\n.peer-com-container .peer-com-table tbody td.ctry svg {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  display: block;\n  margin: 0 auto;\n}\n\n.peer-com-container .peer-com-table tbody td.ticker {\n  text-align: left;\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--text-ticker);\n  padding-right: 4px;\n  cursor: pointer;\n}\n\n.peer-com-container .peer-com-table tbody td.ticker.link-enabled {\n  cursor: pointer;\n}\n.peer-com-container .peer-com-table tbody td.name {\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  text-decoration: none;\n}\n\n.peer-com-container .peer-com-table tbody td.name.link-enabled {\n  cursor: pointer;\n}\n\n.peer-com-container .peer-com-table tbody td.tickerName {\n  text-align: left;\n  padding-left: 36px;\n}\n\n.peer-com-container .peer-com-table tbody td.tickerName .ticker {\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--text-ticker);\n  cursor: pointer;\n}\n\n.peer-com-container .peer-com-table tbody td.tickerName .name {\n  text-align: left;\n  font-weight: 400;\n  font-size: 14px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  padding-right: 4px;\n  text-decoration: none;\n}\n\n.peer-com-container .peer-com-table tbody td.tickerName .tickerNameSmallScreen {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.peer-com-container\n  .peer-com-table\n  tbody\n  td.tickerName\n  .tickerNameSmallScreen\n  .name {\n  width: 100%;\n}\n\n.peer-com-container .peer-com-table tbody td.last,\n.peer-com-container .peer-com-table tbody td.pctchng,\n.peer-com-container .peer-com-table tbody td.mktcap,\n.peer-com-container .peer-com-table tbody td.peratio,\n.peer-com-container .peer-com-table tbody td.divyield,\n.peer-com-container .peer-com-table tbody td.targetprice,\n.peer-com-container .peer-com-table tbody td.beta,\n.peer-com-container .peer-com-table tbody td.avgvol30,\n.peer-com-container .peer-com-table tbody td.rsi,\n.peer-com-container .peer-com-table tbody td.ma5d,\n.peer-com-container .peer-com-table tbody td.ma25d,\n.peer-com-container .peer-com-table tbody td.per,\n.peer-com-container .peer-com-table tbody td.pbr,\n.peer-com-container .peer-com-table tbody td.roe,\n.peer-com-container .peer-com-table tbody td.perf1M,\n.peer-com-container .peer-com-table tbody td.perf3M,\n.peer-com-container .peer-com-table tbody td.perf6M,\n.peer-com-container .peer-com-table tbody td.perf1Y {\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: 0;\n  text-align: right;\n  padding-right: 4px;\n  color: var(--text-primary);\n}\n\n.peer-com-container .peer-com-table tbody td.mktcap span {\n  font-size: 11px;\n  line-height: 100%;\n}\n\n.peer-com-container .peer-com-table tbody td.coscore,\n.peer-com-container .peer-com-table tbody td.div-consensus,\n.peer-com-container .peer-com-table tbody td.overall,\n.peer-com-container .peer-com-table tbody td.fundamental,\n.peer-com-container .peer-com-table tbody td.earnings,\n.peer-com-container .peer-com-table tbody td.valuation,\n.peer-com-container .peer-com-table tbody td.performance,\n.peer-com-container .peer-com-table tbody td.risk,\n.peer-com-container .peer-com-table tbody td.brokerrating {\n  vertical-align: middle;\n  padding-right: 8px;\n  text-align: center;\n}\n\n.peer-com-container .peer-com-table tbody td.coscore span,\n.peer-com-container .peer-com-table tbody td.overall span,\n.peer-com-container .peer-com-table tbody td.fundamental span,\n.peer-com-container .peer-com-table tbody td.earnings span,\n.peer-com-container .peer-com-table tbody td.valuation span,\n.peer-com-container .peer-com-table tbody td.performance span,\n.peer-com-container .peer-com-table tbody td.risk span {\n  width: 36px;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  border-radius: 1px;\n  white-space: nowrap;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.peer-com-container .peer-com-table tbody td.div-consensus span,\n.peer-com-container .peer-com-table tbody td.brokerrating span {\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  border-radius: 1px;\n  white-space: nowrap;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.peer-com-container .peer-com-table tbody td.coscore .score,\n.peer-com-container .peer-com-table tbody td.overall .score,\n.peer-com-container .peer-com-table tbody td.fundamental .score,\n.peer-com-container .peer-com-table tbody td.earnings .score,\n.peer-com-container .peer-com-table tbody td.valuation .score,\n.peer-com-container .peer-com-table tbody td.performance .score,\n.peer-com-container .peer-com-table tbody td.risk .score,\n.peer-com-container .peer-com-table tbody td.brokerrating .score {\n  background-color: var(--surface-secondary);\n  color: var(--text-primary);\n  text-align: center;\n}\n\n.peer-com-container .peer-com-table tbody td.coscore .score-10,\n.peer-com-container .peer-com-table tbody td.overall .score-10,\n.peer-com-container .peer-com-table tbody td.fundamental .score-10,\n.peer-com-container .peer-com-table tbody td.earnings .score-10,\n.peer-com-container .peer-com-table tbody td.valuation .score-10,\n.peer-com-container .peer-com-table tbody td.performance .score-10,\n.peer-com-container .peer-com-table tbody td.risk .score-10,\n.peer-com-container .peer-com-table tbody td.brokerrating .score-10 {\n  background-color: var(--surface-brand);\n  color: var(--text-invert);\n  text-align: center;\n}\n\n.peer-com-container .peer-com-table tbody td.div-consensus .strongbuy {\n  background-color: var(--heatmap-up-5);\n  color: var(--text-invert);\n}\n.peer-com-container .peer-com-table tbody td.firstcolumn,\n.peer-com-container .peer-com-table tbody td.lastcolumn {\n  width: 0;\n}\n.peer-com-container .peer-com-table tbody td:nth-last-child(2) {\n  padding-right: 0px;\n}\n\n.peer-com-container .sortbtn {\n  vertical-align: middle;\n}\n.peer-com-container .rec-strong-buy {\n  background-color: var(--heatmap-up-5);\n  color: var(--text-invert);\n  padding: 3px 8px;\n}\n.peer-com-container .rec-buy {\n  background-color: var(--heatmap-up-4);\n  color: var(--text-invert);\n  text-align: center;\n  padding: 3px 8px;\n}\n.peer-com-container .rec-hold {\n  background-color: var(--surface-secondary);\n  color: var(--text-primary);\n  text-align: center;\n  padding: 3px 8px;\n}\n.peer-com-container .rec-reduce {\n  background-color: var(--heatmap-down-4);\n  color: var(--text-invert);\n  text-align: center;\n  padding: 3px 8px;\n}\n.peer-com-container .rec-sell {\n  background-color: var(--heatmap-down-6);\n  color: var(--text-invert);\n  text-align: center;\n  padding: 3px 8px;\n}\n.peer-com-container .peer-com-whitespace {\n  height: 24px;\n}\n\n.peer-com-container .alignRight {\n  display: flex;\n  justify-content: flex-end;\n}\n.peer-com-container .alignCenter {\n  display: flex;\n  justify-content: center;\n}\n.peer-com-container .per-whiteBorder {\n  border-top: 1px solid var(--surface-primary);\n  border-bottom: 1px solid var(--surface-primary);\n}\n.peer-com-container .peer-com-tbl-cel-flex-container {\n  display: flex;\n  align-items: center;\n  max-width: 90%;\n}\n.peer-com-container .peer-com-tbl-cel-text {\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Small screen only (isSmallScreen = container < 768px). table-layout is fixed,\n   so column sizing must come from `width`. Mirrors StockPeer: give \"Rank\" room\n   (16px + 8/8 padding left no space, so the text overflowed onto the next\n   column) and fix the last data column at 139px with text truncation. */\n@container (max-width: 767.98px) {\n  .peer-com-container .peer-com-table thead .no {\n    width: 37px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .peer-com-container .peer-com-table thead th:nth-last-child(2),\n  .peer-com-container .peer-com-table tbody td:nth-last-child(2) {\n    width: 139px;\n  }\n  .peer-com-container .peer-com-table tbody td:nth-last-child(2),\n  .peer-com-container .peer-com-table tbody td:nth-last-child(2) > div {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n}\n\n@container (min-width: 768px) {\n  .peer-com-container .select-container {\n    padding-left: 24px;\n    padding-right: 24px;\n    padding-bottom: 14px;\n  }\n\n  .peer-com-container select {\n    font-size: 16px;\n    padding: 8px 16px;\n  }\n\n  .peer-com-table-spacer {\n    max-height: unset;\n    height: 8px;\n  }\n\n  .peer-com-container .peer-com-table thead th {\n    height: 32px;\n    &.name {\n      width: 35%;\n      min-width: 35%;\n    }\n    &:nth-last-child(2) {\n      text-align: right;\n      padding-right: 0px;\n    }\n  }\n\n  .peer-com-container .peer-com-table thead th:first-child,\n  .peer-com-container .peer-com-table thead th:last-child {\n    width: 22px;\n  }\n\n  .peer-com-container .peer-com-table thead .no {\n    width: 20px;\n    padding-left: 0;\n  }\n  .peer-com-container .peer-com-table thead .tickerName {\n    padding-left: 8px;\n  }\n  .peer-com-container .peer-com-table thead .numofbrokers {\n    width: 180px;\n  }\n\n  .peer-com-container .peer-com-table tbody tr {\n    height: 40px;\n  }\n\n  .peer-com-container .peer-com-table tbody td {\n    font-size: 16px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    padding-right: 8px;\n\n    &:first-child {\n      padding-left: 24px;\n    }\n    &.no {\n      padding-top: 4px;\n      padding-left: 0;\n      vertical-align: middle;\n    }\n    &.ctry {\n      padding-top: 4px;\n      padding-right: 8px;\n      vertical-align: middle;\n    }\n    &.name {\n    }\n    &.tickerName {\n      padding-left: 8px;\n    }\n    &.tickerName .name {\n      font-size: 12px;\n      padding-right: 8px;\n    }\n    &:nth-last-child(2) {\n      padding-right: 0px;\n    }\n    &:last-child {\n      padding-right: 22px;\n    }\n  }\n\n  .peer-com-container .peer-com-table tbody td.coscore span,\n  .peer-com-container .peer-com-table tbody td.overall span,\n  .peer-com-container .peer-com-table tbody td.fundamental span,\n  .peer-com-container .peer-com-table tbody td.earnings span,\n  .peer-com-container .peer-com-table tbody td.valuation span,\n  .peer-com-container .peer-com-table tbody td.performance span,\n  .peer-com-container .peer-com-table tbody td.risk span {\n    width: 44px;\n  }\n\n  .peer-com-container .peer-com-table thead .ticker,\n  .peer-com-container .peer-com-table tbody td.ticker,\n  .peer-com-container .peer-com-table thead .ctry,\n  .peer-com-container .peer-com-table tbody td.ctry {\n    padding-left: 16px;\n  }\n\n  .peer-com-container .custom-select-wrapper {\n    max-width: 345px;\n    width: 100%;\n  }\n}\n\n@container (min-width: 1200px) {\n  .peer-com-container .peer-com-table tbody td.pctchng {\n    background-color: transparent;\n  }\n  .peer-com-container .peer-com-table tbody td.pctchng.positive {\n    color: var(--text-up-color);\n  }\n  .peer-com-container .peer-com-table tbody td.pctchng.negative,\n  .peer-com-container .peer-com-table tbody td.pctchng.negative-small {\n    color: var(--text-down-color);\n  }\n  .peer-com-container .peer-com-table tbody td.pctchng.nochange {\n    color: var(--text-unchg-color);\n  }\n\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d.positive,\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d.positive {\n    color: var(--text-up-color);\n  }\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d.negative,\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d.negative {\n    color: var(--text-down-color);\n  }\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d.nochange,\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d.nochange {\n    color: var(--text-unchg-color);\n  }\n\n  .peer-com-container.tab-technical .peer-com-table thead th.ma5d,\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma5d,\n  .peer-com-container.tab-technical .peer-com-table thead th.ma25d,\n  .peer-com-container.tab-technical .peer-com-table tbody td.ma25d {\n    min-width: 120px;\n    max-width: 120px;\n    width: 120px;\n  }\n  .peer-com-container.tab-technical .peer-com-table thead th.beta,\n  .peer-com-container.tab-technical .peer-com-table tbody td.beta {\n    min-width: 80px;\n    width: 80px;\n  }\n  .peer-com-container.tab-technical .peer-com-table thead th.avgvol30,\n  .peer-com-container.tab-technical .peer-com-table tbody td.avgvol30 {\n    min-width: 120px;\n    width: 120px;\n  }\n\n  .peer-com-container.tab-fundamentals .peer-com-table thead th.mktcap,\n  .peer-com-container.tab-fundamentals .peer-com-table tbody td.mktcap {\n    width: 125px;\n    min-width: 125px;\n  }\n  .peer-com-container.tab-fundamentals .peer-com-table thead th.per,\n  .peer-com-container.tab-fundamentals .peer-com-table tbody td.per,\n  .peer-com-container.tab-fundamentals .peer-com-table thead th.pbr,\n  .peer-com-container.tab-fundamentals .peer-com-table tbody td.pbr,\n  .peer-com-container.tab-fundamentals .peer-com-table thead th.roe,\n  .peer-com-container.tab-fundamentals .peer-com-table tbody td.roe {\n    width: 90px;\n    min-width: 90px;\n  }\n\n  .peer-com-container.tab-performance .peer-com-table thead th.pctchng,\n  .peer-com-container.tab-performance .peer-com-table tbody td.pctchng {\n    padding-right: 42px;\n  }\n  .peer-com-container.tab-performance .peer-com-table thead th.last,\n  .peer-com-container.tab-performance .peer-com-table tbody td.last {\n    padding-right: 42px;\n  }\n  .peer-com-container.tab-performance .peer-com-table tbody td.perf1Y {\n    padding-right: 8px;\n  }\n\n  .peer-com-container.tab-summary .peer-com-table thead th.divyield,\n  .peer-com-container.tab-summary .peer-com-table tbody td.divyield {\n    max-width: 128px;\n    min-width: 128px;\n    width: 128px;\n  }\n\n  .peer-com-container .peer-com-table tbody td.perf1M,\n  .peer-com-container .peer-com-table tbody td.perf3M,\n  .peer-com-container .peer-com-table tbody td.perf6M,\n  .peer-com-container .peer-com-table tbody td.perf1Y {\n    border-left: 1px solid var(--surface-primary);\n  }\n  .peer-com-container .peer-com-table thead th.perf1M,\n  .peer-com-container .peer-com-table thead th.perf3M,\n  .peer-com-container .peer-com-table thead th.perf6M,\n  .peer-com-container .peer-com-table thead th.perf1Y {\n    text-align: center;\n  }\n\n  .peer-com-container .peer-com-table thead th.brokerrating,\n  .peer-com-container .peer-com-table tbody td.brokerrating {\n    padding-right: 16px;\n  }\n  .peer-com-container .peer-com-table thead th.numofbrokers {\n    text-align: center;\n  }\n  .peer-com-container .peer-com-table thead th.targetprice,\n  .peer-com-container .peer-com-table tbody td.targetprice {\n    min-width: 150px;\n    max-width: 150px;\n    width: 150px;\n  }\n}\n\n.peer-com-container .peer-com-table tbody td.nochange {\n  color: var(--text-unchg-color);\n}\n.peer-com-container .peer-com-table tbody td.positive {\n  color: var(--text-up-color);\n}\n.peer-com-container .peer-com-table tbody td.negative,\n.peer-com-container .peer-com-table tbody td.negative-small {\n  color: var(--text-down-color);\n}\n\n.sort-icon-asc path,\n.sort-icon-desc path {\n  fill: var(--color-brand);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
